import { inlines } from './inlines';
export var taskItem = function taskItem(node, nestedLevel) {
  var _ref = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
    context = _ref.context;
  var result = '';
  node.forEach(function (n) {
    // Generate stars based on depth
    var prefix = Array(nestedLevel).fill('*').join('');
    if (node.attrs.state === 'DONE') {
      result += "".concat(prefix, " -").concat(inlines(n, {
        context: context
      }), "-");
    } else {
      result += "".concat(prefix, " ").concat(inlines(n, {
        context: context
      }));
    }
  });
  return result;
};